// #region Imports
import React from 'react';
import { Route, Routes } from 'react-router-dom';

import ROUTES from './routes';

// #endregion

function AppRoutes() {
  return (
    <Routes>
      {ROUTES.map((element) => (
        <Route
          key={element.path}
          path={element.path}
          element={<element.component />}
        />
      ))}
    </Routes>
  );
}

export default AppRoutes;
